import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Mantissa,
  voices: {
    main: {
      description:
        "soft-spoken insect tactician alto, precise analytical rhythm, gentle healer warmth with alien clicks in texture, dry close mic clarity",
      seed: 11081,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "Life energy is a powerful weapon against evil.",
      },
      { id: "select_2", text: "Mantissa is ready to strike!" },
      { id: "select_3", text: "Mantissa, ready for combat." },
      { id: "select_4", text: "Mantissa is now available." },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "Nothing heals the soul like a bit of gardening…",
      },
      {
        id: "spawn_2",
        text: "We stand together, Quill. The way it should be.",
      },
      { id: "spawn_3", text: "Bodies falter, but the soul fights on!" },
      { id: "spawn_4", text: "The bond we share can't be broken, Adam." },
      {
        id: "spawn_5",
        text: "I was a prisoner of the Collector. One day I will get even.",
      },
      {
        id: "spawn_6",
        text: "Sometimes you can reason with people and sometimes they need a kick in the teeth.",
      },
      {
        id: "spawn_7",
        text: "If the timelines are merged again, I wonder which version of me will survive.",
      },
      {
        id: "spawn_8",
        text: "The Guardians of the Galaxy are misfits who make me feel at home.",
      },
      { id: "spawn_9", text: "Don't hold in your emotions, let them out." },
      { id: "spawn_10", text: "Sometimes empathy is a heavy burden to bear." },
      {
        id: "spawn_11",
        text: "I must regroup with the rest of the Guardians, the Collector MUST be stopped!",
      },
      {
        id: "spawn_12",
        text: "Doom must be a broken man, to be so careless with so many lives.",
      },
      {
        id: "spawn_13",
        text: "We fight for the survival of worlds — not for personal glory.",
      },
      {
        id: "spawn_14",
        text: "We may have to ally with one Doom — temporarily — to defeat the other.",
      },
      { id: "spawn_15", text: "People often mistake empathy for weakness." },
      { id: "spawn_16", text: "Such an emotional time, I like it!" },
      { id: "spawn_17", text: "Martial art sharpens your mind." },
      { id: "spawn_18", text: "The Guardians of the Galaxy value ALL life." },
      {
        id: "spawn_19",
        text: "One may feel empathy for an enemy, and still destroy them.",
      },
      {
        id: "spawn_20",
        text: "Life energy is my eternal guide, and the source of my powers.",
      },
      {
        id: "spawn_21",
        text: "Evil is a rejection of life. Thus I am a guardian against evil.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "Circle of life." },
      { id: "respawn_2", text: "A Guardian… never gives up!" },
      { id: "respawn_3", text: "Hmmm, new perspective." },
      { id: "respawn_4", text: "I built myself a new body. Like it?" },
      { id: "respawn_5", text: "I have some scores to settle!" },
      { id: "respawn_6", text: "Life energy brings me back!" },
      { id: "respawn_7", text: "Mantissa has returned!" },
      { id: "respawn_8", text: "I live to fight another day!" },
    ],
    ult_ally: [{ id: "ult_ally", text: "Friends, gather around!" }],
    ult_enemy: [{ id: "ult_enemy", text: "We are undefeatable!" }],
    secondary: [
      { id: "secondary_1", text: "Chin up." },
      { id: "secondary_2", text: "Let me help." },
      { id: "secondary_3", text: "Help is here." },
    ],
    ability2: [
      { id: "ability2_1", text: "Shake it up." },
      { id: "ability2_2", text: "Focus on the battle!" },
      { id: "ability2_3", text: "Feel better, fight better!" },
    ],
    ability1: [
      { id: "ability1_1", text: "You look tired." },
      { id: "ability1_2", text: "Ease down." },
      { id: "ability1_3", text: "Take a nap." },
    ],
    ability3: [
      { id: "ability3_1", text: "You made…me…angry!" },
      { id: "ability3_2", text: "My anger is healthy." },
      { id: "ability3_3", text: "This is natural anger!" },
    ],
    kill: [
      { id: "kill_1", text: "Makes me feel good." },
      { id: "kill_2", text: "I feel your pain…" },
      { id: "kill_3", text: "Getting my kicks!" },
      { id: "kill_4", text: "Don't come back." },
      { id: "kill_5", text: "Down!" },
      { id: "kill_6", text: "Mantissa strikes!" },
      { id: "kill_7", text: "Too fast for you." },
      { id: "kill_8", text: "I feel bad for you…" },
    ],
    multikill: [
      { id: "multikill_1", text: "Triple success!" },
      { id: "multikill_2", text: "Three times as proud!" },
      { id: "multikill_3", text: "Thrice as nice!" },
      { id: "multikill_4", text: "Five alive!" },
      { id: "multikill_5", text: "A fistful of victories!" },
      { id: "multikill_6", text: "Five in a row!" },
      { id: "multikill_7", text: "I defeated them all by myself!" },
      { id: "multikill_8", text: "Maybe I made myself too powerful." },
      { id: "multikill_9", text: "Hey, team, step it up a little!" },
    ],
    low_hp: [
      { id: "low_hp_1", text: "My life was ebbing…thank you." },
      { id: "low_hp_2", text: "You have saved me!" },
    ],
    healed: [
      { id: "healed_1", text: "My life energy flows stronger!" },
      { id: "healed_2", text: "I am healed!" },
      { id: "healed_3", text: "Healing? Too kind!" },
      { id: "healed_4", text: "Sensational!" },
    ],
  },
} satisfies VoiceScript;

export default script;
